import { render } from "./ConfirmationDialog.vue?vue&type=template&id=316823ea&scoped=true&ts=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=ts"

import "./ConfirmationDialog.vue?vue&type=style&index=0&id=316823ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316823ea"]])

export default __exports__